exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2d8xvnboZbZnsQ0-GU-l9- .ms-Button-label,._2d8xvnboZbZnsQ0-GU-l9- .ms-Button-menuIcon{display:none}", ""]);
// Exports
exports.locals = {
	"commandBarAddin": "_2d8xvnboZbZnsQ0-GU-l9-"
};